// ============ FIREBASE CONFIG ============
export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: "cape-9bb57.firebaseapp.com",
  projectId: "cape-9bb57",
  storageBucket: "cape-9bb57.appspot.com",
  messagingSenderId: "43178413364",
  appId: "1:43178413364:web:1dde7d3d796ccd684e6961",
};
